import {
  Card,
  Box,
  Button,
  TextField,
  Breadcrumbs,
  Stack,
  Typography,
  TableContainer,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useStyles } from "../../theme/theme";

import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Appbar from "../../components/Appbar";
import { Helmet } from "react-helmet-async";
import Body from "../../layout/Body";
import { useLocation } from "react-router-dom";
import TrackChangesSharpIcon from "@mui/icons-material/TrackChangesSharp";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link } from "react-router-dom";
import { use } from "react";
import { getSinglePartnerAction } from "../../redux/toolkit/partner/singlePartner";
import moment from "moment";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { dateFormatStartFun } from "../../helper/dateConverter";

import { dateWisePartnerRevenueAction } from "../../redux/toolkit/partner/dateWisePartnerRevenue";
import { DataGrid } from "@mui/x-data-grid";
import LoadingUI from "../../comman/LoadingUI";
import NoDataFound from "../../comman/NoDataFound";
import { getPublisherAction } from "../../redux/toolkit/publisher/getPublisher";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/partner"
      >
        Partner
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h4">
      Partners
    </Typography>
  </Stack>
);

const SinglePartnerDetails = () => {
  const classes = useStyles();

  const partnerId = useLocation()?.search?.split("?")[1];

  const getPublisherSelector = useSelector((state) => state.getPublisher);
  const { data: publiserData } = getPublisherSelector;

    const [publisher, setPublisher] = useState(null);

    console.log("publisher======================.",publisher)
  

  let dispatch = useDispatch();
  const { data } = useSelector((state) => state.singlePartner);

  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });

  const {
    data: dateWisePartnerRevenueData,
    loading,
    totalAmount,
    totalCount,
  } = useSelector((state) => state.dateWisePartnerRevenue);

  const transactionColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      minWidth: 50,
      headerClassName: "super-app-theme--header",
      renderCell: (index) => {
        return index?.api?.getRowIndex(index?.row?._id) + 1;
      },
    },
    {
      field: "partner_id",
      headerName: "Partner Id",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "user_id",
      headerName: "User ID",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "userEmail",
      headerName: "User Email",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "publisher_id",
      headerName: "Publisher Id",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "app_id",
      headerName: "App Id",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 100,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "raw_amount",
      headerName: "Raw Amount",
      flex: 1,
      minWidth: 100,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "user_payout",
      headerName: "User Payout",
      flex: 1,
      minWidth: 100,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "publisher_payout",
      headerName: "Publisher Payout",
      flex: 1,
      minWidth: 150,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "bonus_amt",
      headerName: "Bonus Amt",
      flex: 1,
      minWidth: 100,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "trans_id",
      headerName: "Trans Id",
      flex: 1,
      minWidth: 150,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography>
            {params?.row?.createdAt
              ? moment(params?.row?.createdAt)
                  .local()
                  .format("DD-MM-YYYY hh:mm:ss A")
              : "-"}
          </Typography>
        );
      },
    },
  ];

  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });

  const dateWiseUser = () => {
    dispatch(
      dateWisePartnerRevenueAction({
        partnerId: partnerId,
        startDate: date?.startDate ? dateFormatStartFun(date?.startDate) : null,
        endDate: date?.endDate ? dateFormatStartFun(date?.endDate) : null,
        publisher_id: publisher?._id ? publisher?._id : null,
      })
    );
  };



  const handleChange = (event) => {
    setPublisher(event.target.value);
  };

  useEffect(() => {
    dispatch(getPublisherAction());
    // setSnack(true);
  }, []);

  useEffect(() => {
    dispatch(getSinglePartnerAction({ partnerId: partnerId }));
  }, []);

  return (
    <>
      <Helmet>
        <title> Real Opinion Admin | Singel Partner</title>
      </Helmet>
      <Appbar breadcrumb={breadcrumb} />
      <Body>
        <Stack spacing={2} direction={"row"} justifyContent={"space-between"}>
          <Typography variant="h6">Partner Details</Typography>
        </Stack>

        <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Min Data"
              value={date?.startDate}
              maxDate={moment()}
              onChange={(newValue) => {
                setDate({ ...date, startDate: newValue });
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Max Data"
              value={date?.endDate}
              minDate={date?.startDate}
              maxDate={moment()}
              onChange={(newValue) => {
                setDate({ ...date, endDate: newValue });
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>

          <Stack direction="row">
            <Box sx={{ minWidth: 150 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Publisher</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={publisher?.name} // ✅ Correct binding
                  label="Publisher"
                  onChange={handleChange} // ✅ Fixes event handling
                >
                  {publiserData?.map((item, i) => (
                    <MenuItem key={i} value={item}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Stack>

          {((date?.startDate && date?.endDate ) || publisher?._id) && (
            <Button variant="contained" onClick={dateWiseUser}>
              find data
            </Button>
          )}
        </Stack>

        <Card sx={{ p: 2, color: "#0C6A96" }}>
          <Stack direction="row" justifyContent="space-between">
            <TrackChangesSharpIcon color="#0C6A96" />
            <Typography
              sx={{
                color: "#5E6C8A",
                fontFamily: "Montserrat,sans-serif",
                fontStyle: "normal",
              }}
              variant="subtitle2"
            >
              {" "}
              Partner Total Revenue
            </Typography>
            {/* <IconButton sx={{ color: '#5E6C8A' }} onClick={handleRefeash}><CachedIcon /></IconButton> */}
          </Stack>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box direction="row">
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  Name :{" "}
                </Typography>
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  {data?.name}
                </Typography>
              </Box>

              <Box direction="row">
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  {" "}
                  TotalPayout :{" "}
                </Typography>
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  {Number(data?.totalPayout).toFixed(4)}
                </Typography>
              </Box>

              <Box direction="row">
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  {" "}
                  TotalRevenue :{" "}
                </Typography>
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  {Number(data?.totalRevenue).toFixed(4)}
                </Typography>
              </Box>

              <Box direction="row">
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  Is Deleted :{" "}
                </Typography>
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  {data?.is_deleted ? "true" : "false"}
                </Typography>
              </Box>
              <Box direction="row">
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  Is Active :{" "}
                </Typography>
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  {data?.is_active ? "true" : "false"}
                </Typography>
              </Box>

              {dateWisePartnerRevenueData && (
                <Box direction="row">
                  <Typography
                    variant="h10"
                    color="primary"
                    sx={{ fontWeight: 600, color: "#071D45" }}
                  >
                    {" "}
                    DateWise Total Revenue :{" "}
                  </Typography>
                  <Typography
                    variant="h10"
                    color="primary"
                    sx={{ fontWeight: 600, color: "#071D45" }}
                  >
                    {totalAmount ? Number(totalAmount)?.toFixed(4) : "---"}
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </Card>

        <Card sx={{ mt: 2 }}>
          <TableContainer sx={{ width: "100%" }}>
            <Stack
              direction={"row"}
              justifyContent="space-between"
              alignItems={"center"}
            >
              <Typography sx={{ ml: 3, my: 2 }} variant="h6">
                Partner Transaction
              </Typography>
              {/* <IconButton sx={{ mr: 3, my: 2 }} onClick={handleRefresh}><CachedIcon /></IconButton> */}
            </Stack>

            <Paper
              sx={{
                bgcolor: "#fff",
                "& .super-app-theme--header": {
                  bgcolor: "#071D45",
                  color: "#fff",
                },
              }}
              elevation={0}
            >
              <DataGrid
                className={classes.root}
                getRowHeight={() => "auto"}
                sx={{ border: 0 }}
                autoHeight
                rows={dateWisePartnerRevenueData || []}
                columns={transactionColumns}
                getRowId={(row) => row?._id}
                disableSelectionOnClick
                experimentalFeatures={{ newEditingApi: true }}
                // pagination

                rowsPerPageOptions={[25, 50, 100]}
                disableColumnSelector
                loading={loading ? <LoadingUI /> : false}
                components={{
                  NoRowsOverlay: () => <NoDataFound />,
                  // Toolbar: GridToolbar,
                }}
                rowCount={totalCount}
                paginationModel={setPageState}
                page={pageState.page}
                pageSize={pageState.pageSize}
                paginationMode="server"
                onPageChange={(newPage) => {
                  setPageState((old) => ({ ...old, page: newPage }));
                }}
                onPageSizeChange={(newPageSize) =>
                  setPageState((old) => ({ ...old, pageSize: newPageSize }))
                }
              />
            </Paper>
          </TableContainer>
        </Card>
      </Body>
    </>
  );
};

export default SinglePartnerDetails;
